import PropTypes from 'prop-types'

/**
 * @typedef {Object} AccountDataSharings
 *
 * @property {string}  [dataSharingApplicationName] - Name of the provider sharing the data.
 * @property {object}  [dataSharingProperties]      - Properties to be shared with other components in a JSON format with undefined properties.
 */
export const accountDataSharingsPropType = PropTypes.shape({
    dataSharingApplicationName: PropTypes.string.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    dataSharingProperties: PropTypes.object
})
